import IonIcon from '@reacticons/ionicons'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import XTwitterLogo from 'src/assets/X-Twitter.svg'
import { IExpertFullItemFragment } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

type Props = {
  expert: IExpertFullItemFragment
}

const socialLink = (icon: React.ReactNode, link?: string | null, title?: string) => {
  return link ? (
    <div className="cursor-pointer ml-3 w-[40px] h-[40px] rounded-[20px] bg-navy flex justify-center items-center">
      <Link href={link} passHref className="flex" target="_blank" title={title}>
        {icon}
      </Link>
    </div>
  ) : null
}

export const ExpertOverviewSection: React.FC<Props> = ({ expert }) => {
  const avatar = useDefaultLogo(expert?.avatar?.url)
  const firstName = expert?.firstName || ''
  const lastName = expert?.lastName || ''
  const title = expert?.title || ''
  const fullName = `${firstName} ${lastName}`
  return (
    <div className="px-5 md:pl-0 !max-w-[1100px] w-full mx-auto flex flex-col md:flex-row items-center py-2 md:pb-0">
      <div className="flex-1 flex-col md:flex-row flex my-[2rem] md:my-[4rem]">
        <div className="flex flex-col items-center justify-center">
          <div className="flex justify-center items-center w-full">
            <Image
              src={avatar}
              alt="avatar"
              className="object-fit-cover w-[140px] h-[140px] rounded-[70px]"
              width={500}
              height={500}
              priority
            />
          </div>
        </div>
        <div className="flex flex-col md:ml-[3rem] items-center md:items-start justify-center mt-5 md:mt-0">
          <h1 className="text-[30px] font-secondary font-bold leading-[46px] text-[#202a35]">{fullName}</h1>
          <h2 className="font-primary font-regular text-[18px] leading-[22px] text-darkgray">{title}</h2>
        </div>
      </div>
      <div className="flex-1 flex flex-row justify-end -ml-3">
        {socialLink(
          <Image src={XTwitterLogo} alt="X-Twitter" className="cursor-pointer" width={14} height={14} />,
          expert?.twitter,
          `View ${fullName}'s Twitter Profile`,
        )}
        {socialLink(
          <IonIcon className="text-white cursor-pointer" name="logo-linkedin" />,
          expert?.linkedin,
          `View ${fullName}'s LinkedIn Profile`,
        )}
      </div>
    </div>
  )
}
